export default __webpack_public_path__ + "static/media/step-nav-line.49f0e8a9.svg";